export const CHECKOUT_URL = 'https://diccionario-apple-arg.impultienda.ar'

export const PRICE = '$35.999'
export const PRICE_VALUE = 35999
export const CURRENCY = 'ARS'
export const GUARANTEE_DAYS = 10

export const WHATSAPP_NUMBER = '5491123745788'
export const WHATSAPP_DISPLAY = '11 2374-5788'
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  '¡Hola! Tengo una consulta sobre Diccionario Apple',
)}`

export const INSTAGRAM_HANDLE = '@celularesnuevossaavedra'
export const INSTAGRAM_URL = 'https://instagram.com/celularesnuevossaavedra'
export const CONTACT_EMAIL = 'atencionstockdigital@gmail.com'

export const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/3ZKqG9jV4GuWjo7XfnbzPX/img_portada_web.png'
